export const COUNTRY_NAME_BY_ISO2 = {
	US: 'United States',
	AU: 'Australia',
	DE: 'Germany',
	GB: 'United Kingdom',
	CA: 'Canada',
	FR: 'France',
	IT: 'Italy',
	ES: 'Spain',
	UA: 'Ukraine',
	PL: 'Poland',
	NL: 'Netherlands',
	SE: 'Sweden',
	NO: 'Norway',
	FI: 'Finland',
	DK: 'Denmark',
	CH: 'Switzerland',
	AT: 'Austria',
	BE: 'Belgium',
	IE: 'Ireland',
	PT: 'Portugal',
	CZ: 'Czech Republic',
	SK: 'Slovakia',
	HU: 'Hungary',
	RO: 'Romania',
	BG: 'Bulgaria',
	GR: 'Greece',
	TR: 'Turkey',
	IL: 'Israel',
	AE: 'United Arab Emirates',
	SA: 'Saudi Arabia',
	IN: 'India',
	CN: 'China',
	JP: 'Japan',
	KR: 'South Korea',
	NZ: 'New Zealand',
	MY: 'Malaysia',
	ID: 'Indonesia',
	SG: 'Singapore',
	VN: 'Vietnam',
}

/** Short names and aliases → ISO2. Add new countries here. */
const WISHLIST_COUNTRY_ALIASES = {
	usa: 'US',
	us: 'US',
	'u.s.': 'US',
	'u.s.a.': 'US',
	'united states': 'US',
	'united states of america': 'US',
	america: 'US',
	uk: 'GB',
	'u.k.': 'GB',
	'united kingdom': 'GB',
	'great britain': 'GB',
	england: 'GB',
	canada: 'CA',
	australia: 'AU',
	germany: 'DE',
	ireland: 'IE',
	'new zealand': 'NZ',
	'saudi arabia': 'SA',
	'south korea': 'KR',
	korea: 'KR',
	japan: 'JP',
	malaysia: 'MY',
	indonesia: 'ID',
	singapore: 'SG',
	vietnam: 'VN',
	'united arab emirates': 'AE',
	uae: 'AE',
	india: 'IN',
	china: 'CN',
	france: 'FR',
	netherlands: 'NL',
	holland: 'NL',
}

const buildCountryAliasesToIso2 = () => {
	const map = { ...WISHLIST_COUNTRY_ALIASES }
	Object.entries(COUNTRY_NAME_BY_ISO2).forEach(([iso2, name]) => {
		const key = String(name).trim().toLowerCase()
		if (key && !map[key]) map[key] = iso2
		map[iso2.toLowerCase()] = iso2
	})
	return map
}

export const COUNTRY_ALIASES_TO_ISO2 = buildCountryAliasesToIso2()

export const getCountryNameByIso2 = iso2 => {
	if (!iso2) return ''
	return COUNTRY_NAME_BY_ISO2[String(iso2).toUpperCase()] || iso2
}

const resolveKnownIso2 = value => {
	if (!value) return null
	const trimmed = String(value).trim()
	if (!trimmed) return null

	const fromAlias = COUNTRY_ALIASES_TO_ISO2[trimmed.toLowerCase()]
	if (fromAlias) return fromAlias

	if (/^[A-Z]{2}$/i.test(trimmed)) {
		const upper = trimmed.toUpperCase()
		// Only accept codes we have a display name for — raw 2-letter junk
		// (and non-country strings) must not become pills.
		return COUNTRY_NAME_BY_ISO2[upper] ? upper : null
	}

	const entry = Object.entries(COUNTRY_NAME_BY_ISO2).find(
		([, countryNameValue]) =>
			countryNameValue.toLowerCase() === trimmed.toLowerCase(),
	)
	return entry ? entry[0] : null
}

/**
 * Resolve a target_countries / dream_country value to ISO2.
 * Accepts: ISO2 ("US"), aliases ("UK", "USA"), full names ("United States"),
 * and "City, Country" location strings ("Southfield, United States" → US).
 * City-only strings ("Southfield") return null.
 */
export const getIso2FromCountryName = countryName => {
	if (!countryName) return null

	const name = String(countryName).trim()
	if (!name) return null

	const direct = resolveKnownIso2(name)
	if (direct) return direct

	// Wishlist-style "City, Country" — map from the country segment only.
	const commaIdx = name.lastIndexOf(',')
	if (commaIdx !== -1) {
		return resolveKnownIso2(name.slice(commaIdx + 1))
	}

	return null
}
